// @flow
// $FlowFixMe - TS file
import React, { useState } from 'react';
import styled from 'styled-components';
// $FlowFixMe - TS file
import useV2Query from 'utils/useV2Query';
import { useClient } from 'bk-web-app/ClientContext';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
// $FlowFixMe - TS file
import { SplitFeatureFlags } from 'bk-web-app/features';

import FollowUpViewContainer from './FollowUpViewContainer';
import CategorizationViewContainer from './CategorizationViewContainer';
import type { DateRange, TransactionManagerTab } from './types';
import IssuesViewContainer from './IssuesViewContainer';
import FinancialPackageNotesContainer from './FinancialPackageNotesContainer';
import transactionManagerTabs from './transactionManagerTabs';
import TransactionManagerHeader from './TransactionManagerHeader';
import { GET_PERSONAL_BUSINESS_COUNTS_ONLY } from './queries';
// $FlowFixMe - TS file
import Transactions1099Container from './components/transactions-1099-container/Transactions1099Container';
// $FlowFixMe - TS file
import PersonalTransactionsContainer from './PersonalTransactionsContainer';

const TRANSACTION_MANAGER_HEADER_HEIGHT = 100;

const TransactionManagerLayout = styled.div`
  bottom: 0;
  left: 0;
  min-width: 960px;
  position: absolute;
  right: 0;
  top: 0;
`;

const TransactionManagerHeaderSection = styled.div`
  left: 0;
  height: ${TRANSACTION_MANAGER_HEADER_HEIGHT}px;
  position: absolute;
  right: 0;
  top: 0;
`;

const TransactionManagerMainSection = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: ${TRANSACTION_MANAGER_HEADER_HEIGHT}px;
  overflow: auto;
`;

type TransactionManagerProps = {
  dateRange: DateRange,
  search: string,
  updateQueryParams: Object => void,
  tab: TransactionManagerTab,
};

const TransactionManager = ({
  dateRange,
  search,
  updateQueryParams,
  tab,
}: TransactionManagerProps) => {
  const [personalTransactionCount, setPersonalTransactionCount] = useState(0);
  const client = useClient();
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  const isPersonalBusinessEnabled =
    features[SplitFeatureFlags.PERSONAL_BUSINESS_TRANSACTION_MANAGER]?.value ===
    FeatureValue.FEATURE_ON;

  const { data: countsData } = useV2Query(GET_PERSONAL_BUSINESS_COUNTS_ONLY, {
    variables: { clientId: client.id.toString() },
    skip: !client.id || !isPersonalBusinessEnabled,
  });

  const displayCount =
    countsData?.personalBusinessClassificationDetailsByClient?.unclassifiedEntriesCount ??
    personalTransactionCount;

  return (
    <TransactionManagerLayout>
      <TransactionManagerHeaderSection>
        <TransactionManagerHeader
          dateRange={dateRange}
          search={search}
          updateQueryParams={updateQueryParams}
          tab={tab}
          personalTransactionCount={isPersonalBusinessEnabled ? displayCount : undefined}
          isPersonalBusinessEnabled={isPersonalBusinessEnabled}
        />
      </TransactionManagerHeaderSection>
      <TransactionManagerMainSection>
        {tab === transactionManagerTabs.FOLLOW_UP && <FollowUpViewContainer search={search} />}
        {tab === transactionManagerTabs.CATEGORIZATION && (
          <CategorizationViewContainer dateRange={dateRange} search={search} />
        )}
        {tab === transactionManagerTabs.TRANSACTIONS1099 && (
          <Transactions1099Container dateRange={dateRange} search={search} />
        )}
        {tab === transactionManagerTabs.ISSUES && (
          <IssuesViewContainer dateRange={dateRange} search={search} />
        )}
        {tab === transactionManagerTabs.FINANCIAL_PACKAGE_NOTES && (
          <FinancialPackageNotesContainer dateRange={dateRange} search={search} />
        )}
        {tab === transactionManagerTabs.PERSONAL_TRANSACTIONS && (
          <PersonalTransactionsContainer
            dateRange={dateRange}
            onTransactionCountChange={setPersonalTransactionCount}
            isPersonalBusinessEnabled={isPersonalBusinessEnabled}
          />
        )}
      </TransactionManagerMainSection>
    </TransactionManagerLayout>
  );
};

export default TransactionManager;
